import { render, staticRenderFns } from "./XyParent.vue?vue&type=template&id=0248bc10&scoped=true&"
import script from "./XyParent.vue?vue&type=script&lang=js&"
export * from "./XyParent.vue?vue&type=script&lang=js&"
import style0 from "./XyParent.vue?vue&type=style&index=0&id=0248bc10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248bc10",
  null
  
)

export default component.exports